<template>
    <div>
        <icon v-show="loading" scale="3" name="spinner" spin></icon>
        <PassTypeForm v-if="!loading" :passType="passType"></PassTypeForm>
    </div>
</template>

<script>
import api from '../api'
import PassTypeForm from './PassTypeForm'
export default {
    name: "PassType",
    components: {
        PassTypeForm
    },
    data() {
        return {
            passType: {},
            loading: true
        };
    },
    mounted() {
        this.updateData()
    },
    beforeRouteUpdate (to, from, next) {
        // react to route changes...
        // don't forget to call next()
        this.updateData()
        next()
    },
    methods: {
        updateData() {
            console.log('updateData')
            if(this.$route.params.id == 'new') {
                this.passType = {
                    id: null,
                    name: '',
                    price: 0,
                    type: '',
                    age: 'Adult',
                    days_limit: null,
                    organisations: []
                }
                this.loading = false
            }
            if(!isNaN(this.$route.params.id)) {
                this.loading = true
                console.log('fetch pass type details')
                var that = this
                api.getAllPassTypeDetails(this.$route.params.id).then(res => {
                    that.passType = res.data.ret_msg;
                    console.log('tis');
                    console.log(that.passType)
                    that.loading = false
                })
            }
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PassType.vue